import { useState } from 'react';
import { shell } from '../../shell/shellClasses';
import { downloadAllDebugCsvs, type DebugExportModels } from './exportAll';

export function DebugExportBar(models: DebugExportModels) {
  const [busy, setBusy] = useState(false);
  const ready = Boolean(
    models.brief || models.kpis || models.overlay || models.pulse || models.ops || models.map,
  );

  const onClick = async () => {
    if (!ready || busy) return;
    setBusy(true);
    try {
      await downloadAllDebugCsvs(models);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex flex-wrap items-center justify-end gap-2">
      <button
        type="button"
        className={`${shell.control} ${shell.focusRing} text-xs ${shell.muted}`}
        disabled={!ready || busy}
        onClick={() => {
          void onClick();
        }}
      >
        {busy ? 'Preparing CSV…' : 'Download all figures (CSV)'}
      </button>
    </div>
  );
}
